export function transformStringInput(value?: string | null): string {
    return value ?? '';
}
